var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return "Selection" == _vm.prop
    ? _c("el-table-column", { attrs: { type: "selection", width: "35" } })
    : "TicketMark" == _vm.prop
    ? _c("el-table-column", {
        attrs: { label: "关注", align: "center", width: "60" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(scope) {
              return [
                _c("TicketMark", { attrs: { ticketNo: scope.row.orderId } })
              ]
            }
          }
        ])
      })
    : "TicketNo_Share" == _vm.prop
    ? _c("el-table-column", {
        attrs: {
          label: "编号",
          align: "center",
          width: _vm.isWide() ? 200 : 50
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(scope) {
              return [
                _c(
                  "span",
                  {
                    staticClass: "ticket_no_span",
                    attrs: { title: scope.row.orderId }
                  },
                  [_vm._v(_vm._s(scope.row.orderId))]
                ),
                _vm._v(" "),
                _vm.isWide()
                  ? _c("TicketShare", { attrs: { ticket: scope.row } })
                  : _vm._e()
              ]
            }
          }
        ])
      })
    : "TicketNo" == _vm.prop
    ? _c("el-table-column", {
        attrs: { label: "编号", align: "center", width: "200" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(scope) {
              return [_c("span", [_vm._v(_vm._s(scope.row.orderId))])]
            }
          }
        ])
      })
    : "TicketStatus" == _vm.prop
    ? _c("el-table-column", {
        attrs: { label: "状态", align: "center", width: "80" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(scope) {
              return [
                scope.row.orderStatus == 2
                  ? _c("span", { staticClass: "ticket_status_2" }, [
                      _vm._v(
                        _vm._s(
                          _vm.ticketStatusIntToString(scope.row.orderStatus)
                        )
                      )
                    ])
                  : scope.row.orderStatus == 3
                  ? _c("span", { staticClass: "ticket_status_3" }, [
                      _vm._v(
                        _vm._s(
                          _vm.ticketStatusIntToString(scope.row.orderStatus)
                        )
                      )
                    ])
                  : scope.row.orderStatus == 5
                  ? _c("span", { staticClass: "ticket_status_5" }, [
                      _vm._v(
                        _vm._s(
                          _vm.ticketStatusIntToString(scope.row.orderStatus)
                        )
                      )
                    ])
                  : scope.row.orderStatus == 6
                  ? _c("span", { staticClass: "ticket_status_6" }, [
                      _vm._v(
                        _vm._s(
                          _vm.ticketStatusIntToString(scope.row.orderStatus)
                        )
                      )
                    ])
                  : _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.ticketStatusIntToString(scope.row.orderStatus)
                        )
                      )
                    ])
              ]
            }
          }
        ])
      })
    : "TicketTitle_ShareIfWide_Tag" == _vm.prop
    ? _c("el-table-column", {
        attrs: {
          label: "标题",
          align: "left",
          sortable: "custom",
          prop: "order_title"
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(scope) {
              return [
                _c("TicketTitle", {
                  attrs: {
                    ticketTitle: scope.row.orderTitle,
                    ticketNo: scope.row.orderId
                  }
                }),
                _vm._v(" "),
                !_vm.isWide()
                  ? _c("TicketShare", { attrs: { ticket: scope.row } })
                  : _vm._e(),
                _vm._v(" "),
                _c("TicketTag", { attrs: { ticketNo: scope.row.orderId } })
              ]
            }
          }
        ])
      })
    : "TicketTitle" == _vm.prop
    ? _c("el-table-column", {
        attrs: {
          label: "标题",
          align: "left",
          sortable: "custom",
          prop: "order_title"
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(scope) {
              return [
                _c("TicketTitle", {
                  attrs: {
                    ticketTitle: scope.row.orderTitle,
                    ticketNo: scope.row.orderId
                  }
                })
              ]
            }
          }
        ])
      })
    : "TicketPriority" == _vm.prop
    ? _c("el-table-column", {
        attrs: {
          label: "优先级",
          align: "center",
          sortable: "custom",
          prop: "order_priority",
          width: "100"
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(scope) {
              return [
                _vm._v(
                  " " +
                    _vm._s(_vm._getPriorityName(scope.row.orderPriority)) +
                    " "
                )
              ]
            }
          }
        ])
      })
    : "TicketType" == _vm.prop
    ? _c("el-table-column", {
        attrs: {
          label: "类型",
          align: "center",
          sortable: "custom",
          prop: "order_type",
          width: "105"
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(scope) {
              return [_c("TicketType", { attrs: { id: scope.row.orderType } })]
            }
          }
        ])
      })
    : "CreatorUser" == _vm.prop
    ? _c("el-table-column", {
        attrs: {
          label: "创建人",
          align: "center",
          sortable: "custom",
          prop: "creator_id",
          width: "115"
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(scope) {
              return [
                _c("TicketUser", {
                  attrs: {
                    ticketNo: scope.row.orderId,
                    userId: scope.row.creatorId
                  }
                })
              ]
            }
          }
        ])
      })
    : "DealUser" == _vm.prop
    ? _c("el-table-column", {
        attrs: {
          label: "处理人",
          align: "center",
          sortable: "custom",
          prop: "deal_user_id",
          width: "100"
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(scope) {
              return [
                _c("TicketUser", {
                  attrs: {
                    ticketNo: scope.row.orderId,
                    userId: scope.row.dealUserId
                  }
                })
              ]
            }
          }
        ])
      })
    : "CreatedAt" == _vm.prop
    ? _c("el-table-column", {
        attrs: {
          label: "创建于",
          align: "center",
          width: "110",
          sortable: "custom",
          prop: "create_time"
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(scope) {
              return [
                _c("span", { attrs: { title: scope.row.createdAt } }, [
                  _vm._v(_vm._s(_vm._f("ticketTime")(scope.row.createdAt)))
                ])
              ]
            }
          }
        ])
      })
    : "UpdatedAt" == _vm.prop
    ? _c("el-table-column", {
        attrs: {
          label: "更新于",
          align: "center",
          width: "110",
          sortable: "custom",
          prop: "update_time"
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(scope) {
              return [
                _c("span", { attrs: { title: scope.row.updatedAt } }, [
                  _vm._v(_vm._s(_vm._f("ticketTime")(scope.row.updatedAt)))
                ])
              ]
            }
          }
        ])
      })
    : "Operation" == _vm.prop
    ? _c("el-table-column", {
        attrs: { label: "操作", align: "center", width: "60", fixed: "right" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(scope) {
              return [
                scope.row.orderStatus == 2
                  ? _c(
                      "a",
                      {
                        attrs: { href: "javascript:;" },
                        on: {
                          click: function($event) {
                            return _vm.dealOrder(
                              scope.row.orderId,
                              scope.row.dealUserId,
                              scope.row.orderStatus,
                              scope.row.orderSuperType
                            )
                          }
                        }
                      },
                      [_vm._v("受理")]
                    )
                  : scope.row.orderStatus == 5
                  ? _c(
                      "a",
                      {
                        attrs: { href: "javascript:;" },
                        on: {
                          click: function($event) {
                            return _vm.closeOrder(scope.row.orderId)
                          }
                        }
                      },
                      [_vm._v("关闭")]
                    )
                  : _c(
                      "a",
                      { attrs: { href: "/ticket/t/" + scope.row.orderId } },
                      [_vm._v("查看")]
                    )
              ]
            }
          }
        ])
      })
    : "CustomerShop" == _vm.prop
    ? _c("el-table-column", {
        attrs: { label: "客服店铺" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(scope) {
              return [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.prop) +
                    " " +
                    _vm._s(scope.row.orderId) +
                    " " +
                    _vm._s(scope.row.callId) +
                    "\n    "
                )
              ]
            }
          }
        ])
      })
    : "PhoneAudio" == _vm.prop
    ? _c("el-table-column", {
        attrs: { label: "通话录音" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(scope) {
              return [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.prop) +
                    " " +
                    _vm._s(scope.row.orderId) +
                    " " +
                    _vm._s(scope.row.callId) +
                    "\n    "
                )
              ]
            }
          }
        ])
      })
    : "PhoneLine" == _vm.prop
    ? _c("el-table-column", {
        attrs: { label: "线路信息" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(scope) {
              return [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.prop) +
                    " " +
                    _vm._s(scope.row.orderId) +
                    " " +
                    _vm._s(scope.row.callId) +
                    "\n    "
                )
              ]
            }
          }
        ])
      })
    : "TargetNumber" == _vm.prop
    ? _c("el-table-column", {
        attrs: { label: "被叫号码" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(scope) {
              return [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.prop) +
                    " " +
                    _vm._s(scope.row.orderId) +
                    " " +
                    _vm._s(scope.row.callId) +
                    "\n    "
                )
              ]
            }
          }
        ])
      })
    : "WorkHour" == _vm.prop
    ? _c("el-table-column", {
        attrs: {
          label: "工时",
          align: "center",
          sortable: "custom",
          width: "200"
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(scope) {
              return [_c("span", [_vm._v(_vm._s(scope.row.workHour))])]
            }
          }
        ])
      })
    : "ContentSummary" == _vm.prop
    ? _c("el-table-column", {
        attrs: { label: "摘要" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(scope) {
              return [_c("span", [_vm._v(_vm._s(scope.row.contentSummary))])]
            }
          }
        ])
      })
    : _c("el-table-column", {
        attrs: { label: _vm.prop + "" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(scope) {
              return [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.prop) +
                    " " +
                    _vm._s(scope.row.orderId) +
                    " " +
                    _vm._s(scope.row.callId) +
                    "\n    "
                )
              ]
            }
          }
        ])
      })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0fbc61c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fbc61c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/ViewTicketTableColumn.vue
// module id = 844
// module chunks = 75